import { OgpSidebarChild, OgpSidebarItems, OgpSidebarSection } from './ogp-sidebar-items.types';

export const withSectionChildren = (
  section: OgpSidebarSection,
  children: OgpSidebarChild[]
): OgpSidebarSection => ({
  key: section.key,
  name: section.name,
  children,
});

export const mapOgpSidebarItems = (
  sidebarItems: OgpSidebarItems,
  updateSection: (section: OgpSidebarSection) => OgpSidebarSection
): OgpSidebarItems => sidebarItems.map(updateSection);
